<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del" @imp='imp' ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="ProMPSHeaderViewInfo"
                        :filter_language="['active_flag']"
                        :filter_date="['start_period','end_period']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[137]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')" width="150"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="start_period" :label="$t('getapi[7024]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="end_period" :label="$t('getapi[7025]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="active_flag" :label="$t('getapi[7026]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="mps_type" :label="$t('getapi[7027]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="mrp_type" :label="$t('getapi[7028]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="data_process_type" :label="$t('getapi[7029]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div style="width:920px;min-width:920px">
                    <table>
                        <tr>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[112]') }}</td>
                            <td style="width:200px;min-width:200px">
                                <routejump :urlNo="12">
                                <el-input  type="text" v-model="dataDetail.Head.part_code"
                                           readonly
                                           class="mcolor"
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectPart()"></i>
                                </el-input>
                                </routejump>
                                <!--<el-input type="text" size="mini" v-model="dataDetail.Head.part_code" :disabled="true"></el-input>-->
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[149]') }}</td>
                            <td style="width:160px;min-width:160px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.part_version" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[410]') }}</td>
                            <td style="width:160px;min-width:160px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.create_person" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[7030]') }}</td>
                            <td style="width:160px;min-width:160px"><el-checkbox  v-model="dataDetail.Head.active_flag" @change="cs" true-label="1" false-label="0"></el-checkbox></td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[7027]') }}</td>
                            <td>
                                <el-select filterable v-model="dataDetail.Head.mps_type_id" size="mini" style="width:100%">
                                    <el-option v-for="item in MPSType" :key="item.Code" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                            </td>
                            <td>{{ $t('getapi[2573]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.kuqty" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[135]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.create_time" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[888]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.part_master_unit" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[7028]') }}</td>
                            <td>
                                <el-select filterable v-model="dataDetail.Head.mrp_type_id" size="mini" style="width:100%">
                                    <el-option v-for="item in MRPType" :key="item.Code" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                            </td>
                            <td>{{ $t('getapi[7031]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.start_period" type="date" size="mini"
                                                style="width:100%"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[733]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.modify_person" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1479]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.item_code" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[7029]') }}</td>
                            <td>
                                <el-select filterable v-model="dataDetail.Head.data_process_type" size="mini" style="width:100%">
                                    <el-option v-for="item in dataProcessType" :key="item.Code" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                            </td>
                            <td>{{ $t('getapi[7025]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.end_period" type="date" size="mini"
                                                style="width:100%"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[1210]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.modify_time" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-tabs :tab-position="'top'" type="" style="margin-top: 5px" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[7032]')" name="0">
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="addLints">{{$t('getapi[6708]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="batchDelLints">{{
                                $t('getapi[4097]') }}
                            </el-button>
                        </div>
                        <el-table
                                id="xdetilpane-0"
                                :data="dataDetail.Lists"
                                @selection-change="handleSelectionChangeLints"
                                :row-class-name="tableRowClassNameDetailLints"
                                :highlight-current-row="true"
                                style="width: 100%; margin-top:2px"
                                :height="tableHeight - 205"
                                header-row-class-name="headerclass"
                                size="mini"
                                border
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column prop="mrp_date" :label="$t('getapi[3664]')">
                                <template scope="scope">
                                    <el-date-picker size="mini" type="date" style="width:100%" v-model="scope.row.mrp_date" v-show="dataDetail.Head.active_flag == 1"></el-date-picker>
                                    <span v-show="dataDetail.Head.active_flag != 1">{{scope.row.mrp_date}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="forecast_qty" :label="$t('getapi[6364]')" align="right">
                                <template scope="scope">
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="scope.row.forecast_qty" @change="gettotal" v-show="dataDetail.Head.active_flag == 1"></el-input>
                                    <span v-show="dataDetail.Head.active_flag != 1">{{scope.row.forecast_qty}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="mps_qty" :label="$t('getapi[7033]')" align="right">
                                <template scope="scope">
                                    <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="scope.row.mps_qty" v-show="dataDetail.Head.active_flag == 1"></el-input>
                                    <span v-show="dataDetail.Head.active_flag != 1">{{scope.row.mps_qty}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7037]')" name="1">
                        <el-table
                                id="xdetilpane-1"
                                :data="dataDetail.SupplyLists" style="width: 100%; margin-top:0px"
                                  :height="tableHeight - 205" header-row-class-name="headerclass" :highlight-current-row="true" size="mini" border>
                            <el-table-column show-overflow-tooltip prop="riqi" :label="$t('getapi[4053]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="supply" :label="$t('getapi[7034]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="demand" :label="$t('getapi[7035]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remain" :label="$t('getapi[7036]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="sr_flag" :label="$t('getapi[2285]')"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7038]')" name="2">
                        <div>
                            <el-button type="primary" size="mini" @click="selectCenter('')">{{$t('getapi[6708]')}}
                            </el-button>
                        </div>
                        <el-table
                                id="xdetilpane-2"
                                :data="dataDetail.ChargeLists" style="width: 100%; margin-top:2px"
                                  :height="tableHeight - 205" header-row-class-name="headerclass" :highlight-current-row="true" size="mini" border>
                            <el-table-column prop="workcenter_code" :label="$t('getapi[4361]')">
                                <template scope="scope">
                                    <el-input  type="text" v-model="scope.row.workcenter_code"
                                               readonly
                                               class="mcolor"
                                               size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectCenter(scope)"></i>
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="workcenter_name" :label="$t('getapi[882]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="unit_charge" :label="$t('getapi[7039]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="total_unit_charge" :label="$t('getapi[7040]')">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="charge_unit" :label="$t('getapi[6366]')"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ProMPSHeaderViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[3989]')" queryData="ProMPSHeaderViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--选择物料-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/MPS/GetMpsPartPopupList'" @callback="getPart" ref="part"></selector>
        <!--工作中心代码-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/MPS/GetWorkCenterPopupList'" @callback="getCenter" ref="center"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '2_mpsview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_mpsview'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                RightSelectIndex: '0',
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail: {
                    Head: {},
                    Lists: [],
                    ChargeLists: [],
                    SupplyLists:[]
                }, // 编辑页面数据详情
                oldDataDetail: '',
                selectDataLints: [],
                dataProcessType:[],
                MPSType:[],
                MRPType:[],
                addoredit: 0,
                oneormore: 1, //1:新增2：修改
                rowindex: -1, // 粗能力行号
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                scrollTop:0,
            };
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            'dataDetail.Lists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            },
            'dataDetail.SupplyLists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            },
            'dataDetail.ChargeLists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            }
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('2_mpsview', that)
            that.userData = sessionStorage.getItem('userData');
            that.user = JSON.parse(that.userData).username;
            that.MPSType = Array.methods.getMPSType();
            that.MRPType = Array.methods.getMRPType();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            tableRowClassNameDetailLints({row, rowIndex}){
                row.index = rowIndex;
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ProMPSHeaderViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[3989]"),this.$t("getapi[26]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                //管理界面                
                if (that.$limits.authority('plv2', 174, 1) == 1) {
                    if (that.total > 0) {
                    //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    else{
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                else if (that.$limits.authority('plv2', 174, 1) == 2) {
                    if (that.$limits.authority('plv3', 174,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 174) == 1) {
                        //编辑级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.Head.mps_part_id)) {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,import,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,import,export');
                        }
                    }
                    if (that.$limits.authority('plv3', 174, 1) == 2) {
                        //删除级
                        if (!that.$limits.fnIsEmpty(that.dataDetail.Head.mps_part_id)) {
                            that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,import,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,import,export');
                        }
                    }
                }
                else{
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    if (that.$limits.authority('plv2', 172, 1)>0) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } 
                    }
                }
                
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_mpsview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProMPSHeaderViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pro/MPS/MPSDataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.id == row.mps_part_id){
                    return
                }
                that.timeId = setTimeout(() => {
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.Lists.length;i++){
                        delete datacopy.Lists[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.id = row.mps_part_id;
                                that.getDetail(that.id);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.id = row.mps_part_id;
                        that.getDetail(that.id);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(id) {
                let that = this;
                if (that.$limits.authority('plv2', 174, 1) < 1) {
                    return;
                }
                that.addoredit = 1;
                let datetime = Common.methods.getDatetime()
                let parm = {
                    Id: id
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pro/MPS/GetMPSBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.dataDetail.Head.active_flag = that.dataDetail.Head.active_flag.toString()
                        that.dataDetail.Head.mrp_type_id = that.dataDetail.Head.mrp_type_id.toString()
                        that.dataDetail.Head.mps_type_id = that.dataDetail.Head.mps_type_id.toString()
                        that.dataDetail.Head.modify_time = datetime
                        that.dataDetail.Head.modify_person = that.user
                        that.dataDetail.Head.isadd = 0
                        that.authority();
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                    }
                    loadingInstance.close()
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.addoredit = 0;
                that.id = ''
                let date = Common.methods.getDate()
                let datetime = Common.methods.getDatetime()
                that.dataDetail = {
                    Head: {
                        mps_part_id: 0,
                        start_period: date,
                        end_period: date,
                        active_flag: '1',
                        data_process_type: '',
                        mps_type_id: '',
                        mps_type_name: '',
                        mrp_type_id: '',
                        mrp_type_name: '',
                        calc_time: '',
                        create_person: that.user,
                        create_time: datetime,
                        modify_person: '',
                        modify_time: '',
                        audit_person: '',
                        audit_time: '',
                        remark: '',
                        field: '',
                        item_code: '',
                        part_code: '',
                        part_version: '',
                        part_master_unit: '',
                        kuqty: 0,
                        isadd: 1,
                    },
                    Lists: [],
                    ChargeLists: [],
                    SupplyLists: []
                };
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.getView();
                if (that.addoredit != 0) {
                    that.getDetail(that.id)
                } else {
                    that.add()
                }*/
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit != 0){
                                that.getView();
                                that.getDetail(that.id)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if(that.addoredit != 0){
                        that.getView();
                        that.getDetail(that.id)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndexs,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pro/MPS/MPSExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ProMPSHeaderViewInfo",
                    fromname: that.$t('getapi[3989]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                let parm = {
                    Head: that.dataDetail.Head,
                    Lists: that.dataDetail.Lists,
                    ChargeLists: that.dataDetail.ChargeLists,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Pro/MPS/SaveData', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.id = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                });
            },
            addLints(){
                let that = this
                let date = Common.methods.getDate()
                that.dataDetail.Lists = [...that.dataDetail.Lists,{
                    exclusively_id: '',
                    relation_mps_part_id: '',
                    mrp_date: date,
                    supply_notice: '',
                    require_notice: '',
                    forecast_qty: '',
                    mps_qty: '',
                    create_person: '',
                    create_time: '',
                    modify_person: '',
                    modify_time: '',
                    remark: ''
                }]
            },
            handleSelectionChangeLints(val){
                let that = this
                that.selectDataLints = []
                for(let i = 0;i<val.length;i++){
                    that.selectDataLints.push(val[i])
                }
            },
            batchDelLints(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            ids: ''
                        };
                        for (let i = that.selectDataLints.length - 1; i >= 0; i--) {
                            that.dataDetail.Lists.splice(that.selectDataLints[i].index, 1);
                            if(that.selectDataLints[i].exclusively_id !=""){
                                parm.ids = parm.ids + that.selectDataLints[i].exclusively_id + ','
                            }
                        }
                        if(parm.ids != ''){
                            that.$http.urlpost('/Pro/MPS/DelMPSLine', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //获取物料
            selectPart() {
                let that = this;
                that.$refs.part.clearInput(true);
            },
            getPart(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.mps_part_id = data.exclusively_id
                that.dataDetail.Head.part_code = data.part_code
                that.dataDetail.Head.part_master_unit = data.part_master_unit
                that.dataDetail.Head.part_version = data.part_version
                that.dataDetail.Head.item_code = data.item_code
                that.dataDetail.Head.kuqty = data.kuqty
            },
            //获取工作中心
            selectCenter(row) {
                let that = this;
                if(that.dataDetail.Head.mps_part_id == ''){
                    that.$message.warning(that.$t('getapi[4762]'))//'物料不能为空！'
                    return
                }
                if(row != ''){
                    that.rowindex = row.$index
                    that.oneormore = 2
                } else {
                    that.oneormore = 1
                }
                let param = {
                    Id: that.dataDetail.Head.mps_part_id
                }
                that.$refs.center.clearInput(true,param);
            },
            getCenter(data){
                let that = this
                if(that.oneormore == 1){
                    that.dataDetail.ChargeLists = [...that.dataDetail.ChargeLists,{
                        exclusively_id: 0,
                        relation_mps_part_id: 0,
                        workcenter_code: data.workcenter_code,
                        workcenter_name: data.workcenter_name,
                        unit_charge: data.sum_manhour,
                        create_person: '',
                        create_time: '',
                        modify_person: '',
                        modify_time: '',
                        remark: '',
                        charge_unit: data.report_measure_method,
                        total_unit_charge: ''
                    }]
                } else {
                    that.dataDetail.ChargeLists[that.rowindex].exclusively_id = 0
                    that.dataDetail.ChargeLists[that.rowindex].relation_mps_part_id = 0
                    that.dataDetail.ChargeLists[that.rowindex].workcenter_code = data.workcenter_code
                    that.dataDetail.ChargeLists[that.rowindex].workcenter_name = data.workcenter_name
                    that.dataDetail.ChargeLists[that.rowindex].unit_charge = data.sum_manhour
                    that.dataDetail.ChargeLists[that.rowindex].create_person = ''
                    that.dataDetail.ChargeLists[that.rowindex].create_time = ''
                    that.dataDetail.ChargeLists[that.rowindex].modify_person = ''
                    that.dataDetail.ChargeLists[that.rowindex].modify_time = ''
                    that.dataDetail.ChargeLists[that.rowindex].remark = ''
                    that.dataDetail.ChargeLists[that.rowindex].charge_unit = data.report_measure_method
                    that.dataDetail.ChargeLists[that.rowindex].total_unit_charge = ''
                }
                that.gettotal()
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            Id : that.dataDetail.Head.mps_part_id
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Pro/MPS/DelMPS', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            gettotal(){
                let that = this
                let qty = 0
                for(let i = 0;i<that.dataDetail.Lists.length;i++){
                    qty = qty + that.dataDetail.Lists[i].forecast_qty
                }
                for(let i = 0;i<that.dataDetail.ChargeLists.length;i++){
                    that.dataDetail.ChargeLists[i].total_unit_charge = that.dataDetail.ChargeLists[i].unit_charge * qty
                }
            },
            cs(){
                let that = this
                that.dataDetail.Head.active_flag
            },
            imp(){
                let item = {
                //label: '主计划导入',
                label: '通用导入',
                name: 'exp',
                path: '/exp/10',
                url: '/exp/10',
                icon: 'video-play'
                };
                this.$router.push({ path: '/exp/10' });
                this.$store.commit('selectMenu', item);
            },
            selectInfo(tab){
                let that = this
                that.RightSelectIndex = tab.name
                this.$nextTick(function(){
                    this.$processdata.initFormRight(that.RightSelectIndex)
                });
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 174,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }
</style>
